import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "n-icon-stop",
  "use": "n-icon-stop-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"n-icon-stop\">\n    <rect x=\"5\" y=\"5\" width=\"10\" height=\"10\" rx=\"1\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol